import { render, staticRenderFns } from "./GoodsRelease.vue?vue&type=template&id=532679ca&scoped=true&"
import script from "./GoodsRelease.vue?vue&type=script&lang=js&"
export * from "./GoodsRelease.vue?vue&type=script&lang=js&"
import style0 from "./GoodsRelease.vue?vue&type=style&index=0&id=532679ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532679ca",
  null
  
)

export default component.exports